<template>
  <!-- start::compoent container -->
  <div>
    <!-- start::popup -->
    <vs-popup
      class="holamundo"
      :title="title"
      :active="displayPopUp"
      @close="closePopUp"
    >
      <!-- start::form -->
      <form>
        <!-- start::validation observer -->
        <validation-observer v-slot="{ invalid }">
          <!-- start::name -->
          <validation-provider rules="required" v-slot="{ errors }">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Όνομα</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="name" />
              </div>
            </div>
            <div class="vx-col text-danger text-right">{{ errors[0] }}</div>
          </validation-provider>
          <!-- end::name -->

          <!-- start::last name -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Επώνυμο</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="lastName" />
            </div>
          </div>
          <!-- end::last name -->

          <!-- start::username -->
          <validation-provider rules="required|min:6" v-slot="{ errors }">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Username</span> <span>*</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="username"
                />
              </div>
            </div>
            <div class="vx-col text-danger text-right">{{ errors[0] }}</div>
          </validation-provider>
          <!-- end::username -->

          <!-- start::email -->
          <validation-provider rules="required|email" v-slot="{ errors }">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>E-mail</span><span>*</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="email"
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-mail"
                  icon-no-border
                  v-model="email"
                />
              </div>
            </div>
            <div class="vx-col text-danger text-right">{{ errors[0] }}</div>
          </validation-provider>
          <!-- end::email -->

          <!-- start::password -->
          <validation-provider rules="required" v-slot="{ errors }">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Κωδικός</span><span>*</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="password"
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-lock"
                  icon-no-border
                  v-model="pass"
                />
              </div>
            </div>
            <div class="vx-col text-danger text-right">{{ errors[0] }}</div>
          </validation-provider>
          <!-- end::password -->

          <!-- start::role -->
          <validation-provider
            :rules="title === 'Δημιουργία χρήστη' ? 'required' : ''"
            v-slot="{ errors }"
          >
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Ρόλος</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <v-select
                  :clearable="false"
                  v-model="role"
                  name="role"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :options="['Διαχειριστής', 'Χρήστης']"
                />
              </div>
            </div>
            <div class="vx-col text-danger text-right">{{ errors[0] }}</div>
          </validation-provider>
          <!-- end::role -->

          <!-- start::isActive -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Ενεργός</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-switch v-model="isActive" />
            </div>
          </div>
          <!-- end::isActive -->

          <!-- start::sendMassiveEmail -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Αποστολή συγκεντρωτικού email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-switch v-model="sendMassiveEmail" />
            </div>
          </div>
          <!-- end::sendMassiveEmail -->

          <!-- start::sendOnlyChanges -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Αποστολή email μόνο αλλαγών</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-switch v-model="sendOnlyChanges" />
            </div>
          </div>
          <!-- end::sendOnlyChanges -->

          <!--<div class="vx-row" v-if="!validateForm()" >
              <vs-alert class="mt-5" >Παρακαλώ συμπληρώστε όλα τα πεδία με *.</vs-alert>
          </div>-->

          <!-- start::actions -->
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                :disabled="invalid"
                class="mb-2 text-right"
                @click="addOrUpdateUser"
              >
                Αποθήκευση
              </vs-button>
            </div>
          </div>
          <!-- end::actions -->
        </validation-observer>
        <!-- end::validation observer -->
      </form>
      <!-- end::form -->
    </vs-popup>
    <!-- end::popup -->
  </div>
  <!-- end::component container -->
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})

extend('email', {
  ...email,
  message: 'Το email δεν είναι σωστό',
})

extend('min', {
  ...min,
  message: 'Ελάχιστο πλήθος χαρακτήρων 6',
})

extend('max', {
  ...max,
  message: 'Μέγιστο πλήθος χαρακτήρων 10',
})

export default {
  name: 'UserPopUp',
  components: { vSelect, ValidationObserver, ValidationProvider },
  data() {
    return {
      pass: '',
    }
  },
  computed: {
    item() {
      return this.$store.getters.getUser
    },
    // Getter and Setter for name
    name: {
      get() {
        return this.$store.getters.getUser.name
      },
      set(value) {
        this.$store.dispatch('setUserName', value)
      },
    },
    // Getter and Setter for surname
    lastName: {
      get() {
        return this.$store.getters.getUser.surname
      },
      set(value) {
        this.$store.dispatch('setUserLastName', value)
      },
    },
    // Getter and Setter for username
    username: {
      get() {
        return this.$store.getters.getUser.username
      },
      set(value) {
        this.$store.dispatch('setUserUsername', value)
      },
    },
    // Getter and Setter for email
    email: {
      get() {
        return this.$store.getters.getUser.email
      },
      set(value) {
        this.$store.dispatch('setUserEmail', value)
      },
    },
    // Getter and Setter for password
    password: {
      get() {
        return this.$store.getters.getUser.password
      },
      set(value) {
        this.$store.dispatch('setUserPassword', value)
      },
    },
    // Getter and Setter for role
    role: {
      get() {
        return this.$store.getters.getUser.role
      },
      set(value) {
        this.$store.dispatch('setUserRole', value)
      },
    },

    // Getter and Setter for isActive
    isActive: {
      get() {
        return this.$store.getters.getUser.isActive
      },
      set(value) {
        this.$store.dispatch('setUserIsActive', value)
      },
    },

    sendMassiveEmail: {
      get() {
        return this.$store.getters.getUser.sendMassiveEmail
      },
      set(value) {
        this.$store.dispatch('setUserSendMassiveEmail', value)
      },
    },

    sendOnlyChanges: {
      get() {
        return this.$store.getters.getUser.sendOnlyChanges
      },
      set(value) {
        this.$store.dispatch('setUserSendOnlyChanges', value)
      },
    },

    title() {
      return this.$store.getters.getPopUpTitle
    },
    displayPopUp() {
      return this.$store.getters.getDisplayPopUp
    },
  },
  methods: {
    closePopUp() {
      // 1. Close the popup
      this.$store.dispatch('displayUserPopUp', false)
      // 2. Reset pop up title
      this.$store.dispatch('setUserPopUpTitle', '');
      // 3. Set Current user to an empty object
      this.$store.dispatch('userSetter', {})
    },
    addOrUpdateUser() {
      if (this.pass !== '') {
        this.$store.dispatch('setUserPassword', this.pass)
      }

      // Update user
      if (this.title === 'Επεξεργασία χρήστη') {
        // 1. Update the user
        const payload = this.item
        this.$store.dispatch('editUser', payload).then(() => {
          // 2. Notify with success message
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχής ενημέρωση',
            position: 'top-right',
            text: 'Η ενημέρωση των στοιχείων του χρήστη έγινε με επιτυχία.',
          })
          // 3. Close the modal.
          this.$store.dispatch('displayUserPopUp', false)
        })
      }
      // Create new user
      else {
        const payload = this.item
        this.$store.dispatch('addNewUser', payload).then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχής εγγραφή',
            position: 'top-right',
            text: 'Η προσθήκη νέου χρήστη έγινε με επιτυχία',
          })
          // Close the modal.
          this.$store.dispatch('displayUserPopUp', false)
        })
      }
    },
  },
}
</script>

<style scoped>
</style>
